import React from 'react'
import { useTranslation } from 'react-i18next';
import {Modal, Button} from 'react-bootstrap';
import CustomModalMobileButton from '../CustomModalMobileButton.jsx';

function UserPinModal(props) {
      const { t } = useTranslation();
    
  return (
    <div className="modal show">
          <Modal className="registration_modal" show={props?.showUserPinModal}>
            <Modal.Header closeLabel={t('common.close')}>
              <div className="modal-title h4 long_alias">{t('member.header.userPinUserName')}{props?.alias}</div>
              <CustomModalMobileButton onShowHide={() => props?.closeUserPinPopup()} />
            </Modal.Header>
            <Modal.Body>
              {props?.userPin ?
                <p>{t('member.header.userPin')}{props?.userPin?.pin}</p>
              : 
                <p>{t('member.header.userPinError')}</p>
             }
            </Modal.Body>

            <Modal.Footer>
              <Button variant="primary" onClick={() => { props?.closeUserPinPopup(); }}>
                {t('common.close')}</Button>
            </Modal.Footer>
          </Modal>
        </div>
  )
}

export default UserPinModal